import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { byCard, byCountry } from 'utils';
import {
  config,
  PRODUCT_CODE_AFS,
  PRODUCT_CODE_AU_GEM,
  PRODUCT_CODE_GO,
  PRODUCT_CODE_LOW_RATE,
  PRODUCT_CODE_NZ_GEM,
  PRODUCT_CODE_TWENTY_EIGHT_DEGREES,
} from '_config';

// TODO update with real values from marketing
// https://di.latitudefinancial.com/jira/browse/NZP-410
const getNzMeta = () => {
  return {
    title: 'Gem Visa Application',
    description: 'Gem Visa Application',
    siteUrl: '',
    keywords: '',
  };
};

const getAuMeta = () => {
  return {
    title: `${config.productName ? config.productName : 'David Jones'} credit card application`,
    description: `Earn points, enjoy unrivalled service, and access unique benefits and experiences like no other. Unlock the best of the world in one place with a ${
      config.productName ? config.productName : 'David Jones'
    } credit card application.`,
    siteUrl: '',
    keywords: 'credit card, points, David Jones',
  };
};

const getRobotsValue = (noIndex, noFollow) => {
  const output = [];
  noIndex && output.push('noindex');
  noFollow && output.push('nofollow');
  return output.join(', ');
};

export const Metadata = ({
  url,
  description: _description,
  keywords: _keywords,
  title: _title,
  noIndex = false,
  noFollow = false,
  children,
}) => {
  const robots = getRobotsValue(noIndex, noFollow);

  const getDefaultMeta = byCountry({
    AU: getAuMeta,
    NZ: getNzMeta,
  });

  const defaultMeta = getDefaultMeta();

  const description = _description || defaultMeta.description;
  const keywords = _keywords || defaultMeta.keywords;
  const title = _title || defaultMeta.title;
  const favicon = byCard({
    [PRODUCT_CODE_NZ_GEM]: `${import.meta.env.BASE_URL}favicon-lfs.ico`,
    [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: `${import.meta.env.BASE_URL}favicon-lfs.ico`,
    [PRODUCT_CODE_GO]: `${import.meta.env.BASE_URL}favicon-lfs.ico`,
    [PRODUCT_CODE_AU_GEM]: `${import.meta.env.BASE_URL}favicon-lfs.ico`,
    [PRODUCT_CODE_AFS]: `${import.meta.env.BASE_URL}favicon-lfs.ico`,
    [PRODUCT_CODE_LOW_RATE]: `${import.meta.env.BASE_URL}favicon-lfs.ico`,
    default: `${import.meta.env.BASE_URL}favicon-dj.ico`,
  });

  return (
    <Helmet>
      <link rel="icon" href={favicon} />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {robots && <meta name="robots" content={robots} />}
      {title && <meta property="og:site_name" content={title} />}
      {title && <meta property="og:title" content={title} />}
      <meta property="og:description" content={description} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {children}
    </Helmet>
  );
};
